import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import { getAuth, signOut } from "firebase/auth";
import LogoDark from "../../Cine.mp4";
import LogoLight from "./cinesage.mp4";

const Header = ({ toggleTheme }) => {
    const auth = getAuth();
    const user = auth.currentUser;
    const [isDarkMode, setIsDarkMode] = useState(true); // State variable to track the current mode

    const handleThemeToggle = () => {
        setIsDarkMode(prevMode => !prevMode); // Toggle between light and dark modes
        toggleTheme(); // Call the toggleTheme function to change the theme globally
    };
    const [showOptions, setShowOptions] = useState(false);
    const handleToggle = () => {
        setShowOptions(!showOptions);
    };

    const handleLogout = async () => {
        try {
            await signOut(auth);
            // Handle redirection after logout if needed
        } catch (error) {
            console.error("Error signing out", error);
        }
    };

    // Check if user is admin
    const isAdmin = user && user.email === "jenny1@yahoo.com";
    // Check if user is registered
    const isRegistered = !!user;

    return (
        <nav className="navbar navbar-expand-lg bg-accent">
            <Link to="/" className="navbar-brand">
                {isDarkMode ? (
                    <video className="header__video" autoPlay loop muted>
                        <source src={LogoDark} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <div>
                        <video className="header__video" autoPlay loop muted>
                            <source src={LogoLight} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                )}
            </Link>
            <button className="navbar-toggler" type="button" onClick={handleToggle}>
                <span className="navbar-toggler-icon bg-secondary-subtle"></span>
            </button>
            <div className={`collapse navbar-collapse ${showOptions ? 'show' : ''}`} id="navbarNav">
                <ul className="navbar-nav ml-auto">
                    {!isRegistered && (
                        <li className="nav-item">
                            <NavLink to="/aboutus" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">About Us</NavLink>
                        </li>
                    )}
                    {isAdmin && (
                        <>
                            <li className="nav-item">
                                <NavLink to="/Viewmessages" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">View Messages</NavLink>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/userhistory" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">View Users History</NavLink>
                            </li>

                            <li className="nav-item">
                                <div className="nav-link AJ">
                                    <Link to="/login" onClick={handleLogout} className={`text-${isDarkMode ? 'light' : 'dark'}`} style={{ textDecoration: 'none' }}>
                                        <i className="fas fa-user"></i> Logout
                                    </Link>
                                </div>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/graph" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Graph</NavLink>
                            </li>
                        </>
                    )}
                    {isRegistered && !isAdmin && (
                        <>
                            <li className="nav-item">
                                <NavLink to="/Search" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Search</NavLink>
                            </li>
                            <li className="nav-item">
                                <div className="nav-link AJ">
                                    <Link to="/login" onClick={handleLogout} className={`text-${isDarkMode ? 'light' : 'dark'}`} style={{ textDecoration: 'none' }}>
                                        <i className="fas fa-user"></i> Logout
                                    </Link>
                                </div>
                            </li>

                            <li className="nav-item">
                                <NavLink to="/viewhistory" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">History</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/recommendation" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Recommendation</NavLink>
                            </li>

                            {/* <li className="nav-item">
                                <NavLink to="/Recomd"  activeClassName="active">Recommend</NavLink>
                            </li> */}
                            <li className="nav-item">
                                <NavLink to="/favoritelist" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Saved Favorites</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/Watchlist" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Watch</NavLink>
                            </li>
                            {/* <li className="nav-item">
                                <NavLink to="/fetch" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">fetch favorites</NavLink>
                            </li> */}
                            <li className="nav-item">
                                <NavLink to="/contact" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Contact Us</NavLink>
                            </li>
                            {/* <li className="nav-item">
                                <NavLink to="/movies/top_rated" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Highest Rating</NavLink>
                            </li>
                            <li className="nav-item">
                                <NavLink to="/movies/upcoming" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">Upcoming</NavLink>
                            </li>*/}
                            <li className="nav-item">
                                <NavLink to="/aboutus" className={`nav-link AJ ${isDarkMode ? 'text-light' : 'text-dark'}`} activeClassName="active">About Us</NavLink>
                            </li>
                        </>
                    )}

                    {/* Always show About Us button */}

                    {/* Toggle button for dark and light mode */}
                    <li className="nav-item">
                        <button className={`btn ${isDarkMode ? 'btn-light' : 'btn-dark'}`} onClick={handleThemeToggle}>
                            {isDarkMode ? 'Light Mode' : 'Dark Mode'}
                        </button>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default Header;